import UpdateUserData from "src/context/utils/user/update-user-data"

export const OnAuthStateChange = async ( firebase, setUser, setAuthUser, setCart ) => {
  const updateUserData = ( uid ) => UpdateUserData( firebase, uid, setUser, setAuthUser, setCart )

  try {

    return await firebase
      .auth()
      .onAuthStateChanged( async firebaseUser => {
        if ( firebaseUser ) {

          const isAuthUser = await updateUserData( firebaseUser.uid )
          if ( isAuthUser ) setAuthUser( firebaseUser )

        } else {

          localStorage.setItem( "isLoggedIn", false )
          setAuthUser( null )

        }
      } )
    } catch ( error ) {
      console.log( 'on-auth-state-change', { error } )
    }
}

export default OnAuthStateChange